import { GridCell } from '@progress/kendo-react-grid'
import React from 'react'
import { Badge } from 'reactstrap'

export class TagsCell extends GridCell {
  constructor(props: any) {
    super(props)
  }

  public render() {
    return <td id={`Tags-${this.props.dataItem.id}`}>
      <div>
        {this.props.dataItem.tag.split(',').map((tag: string, index: number) =>
          <Badge key={`${this.props.dataItem.id}-${index}`} color="secondary">{tag}</Badge>)}
      </div>
    </td>}
}



// WEBPACK FOOTER //
// ./src/pages/source-config/filters/render/tag_cell.tsx